import axios from "axios";

const PATH = "/minimumwages";

/**
 * A minimum wage and the day it is valid from. It stays valid until the next minimum wage starts.
 */
export interface MinimumWageDto {
  id: number;
  amount: number;
  validFrom: string;
}

export default {
  /**
   * Returns the minimum wage valid on the given day (`YYYY-MM-DD`), or `null` if none is.
   */
  findMinimumWage(date: string): Promise<MinimumWageDto | null> {
    return axios.get(PATH, {params: {date}})
      .then(response => response.data)
      .catch(error => {
        if (error.response?.status === 404) {
          return null;
        }
        throw error;
      });
  }
};
